/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Map_View_2dInputs */

const en_ui_map_view_2d = /** @type {(inputs: Ui_Map_View_2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2D`)
};

const de_ui_map_view_2d = /** @type {(inputs: Ui_Map_View_2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2D`)
};

/**
* | output |
* | --- |
* | "2D" |
*
* @param {Ui_Map_View_2dInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_view_2d = /** @type {((inputs?: Ui_Map_View_2dInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_View_2dInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_view_2d(inputs)
	return de_ui_map_view_2d(inputs)
});